<template>
  <Toast />
  <ConfirmDialog />
  <ul class="list-none p-0 m-0 flex align-items-center font-medium">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer"
        >INVENTARIO</a
      >
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3 active">TRASPASOS</span>
    </li>
  </ul>
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <div
      class="flex align-items-center flex-column lg:justify-content-center lg:flex-row"
    >
      <span style="border-bottom: 1px solid #005f91; font-size: 1.5rem">
        <strong>REGISTRAR TRASPASO DE PRODUCTOS</strong>
      </span>
    </div>
    <div class="col-12 p-fondo">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-3">
          <span><strong>PREPARADO POR:</strong></span>
          <Dropdown
            v-model="userSelected"
            :options="users"
            optionLabel="name"
            optionValue="id"
          >
          </Dropdown>
        </div>
        <div class="field col-12 md:col-3">
          <span><strong>RECIBIDO POR:</strong></span>
          <Dropdown
            v-model="userRecibeSelected"
            :options="users"
            optionLabel="name"
            optionValue="id"
          >
          </Dropdown>
        </div>
        <div class="field col-12 md:col-3">
          <span><strong>ORIGEN:</strong></span>
          <Dropdown
            v-model="sucursalSelected"
            :options="sucursales"
            optionLabel="nombre"
            optionValue="id"
          >
          </Dropdown>
        </div>
        <div class="field col-12 md:col-3">
          <span><strong>DESTINO:</strong></span>
          <Dropdown
            v-model="sucursalDestinoSelected"
            :options="sucursales"
            optionLabel="nombre"
            optionValue="id"
          >
          </Dropdown>
        </div>
        <div class="field col-12 md:col-6">
          <span><strong>BUSCAR PRODUCTO:</strong></span>
          <AutoComplete
            :dropdown="true"
            field="descripcion"
            v-model="productoSelected"
            :suggestions="productosListadoFiltrado"
            @complete="buscarProducto($event)"
            placeholder="Buscar Producto"
            @item-select="agregarProductoDetalle"
          >
            <template #item="slotProps">
              <div>
                <strong
                  v-if="slotProps.item.codigo_interno"
                  v-tooltip.top="'Código Interno'"
                  >{{ slotProps.item.codigo_interno }} ***</strong
                >

                <strong
                  v-if="slotProps.item.codigo_origen"
                  v-tooltip.top="'Código Origen'"
                  >{{ slotProps.item.codigo_origen }} ***</strong
                >
                {{ slotProps.item.descripcion }} <strong>**</strong>
                {{ slotProps.item.fabrica_nombre }} <strong>**</strong>
                <span
                  :class="
                    stockClass(
                      slotProps.item.stock.length > 0
                        ? slotProps.item.stock[0].cantidad
                        : 0
                    )
                  "
                  ><strong>{{
                    slotProps.item.stock.length > 0
                      ? slotProps.item.stock[0].cantidad
                      : 0
                  }}</strong></span
                >
              </div>
            </template>
          </AutoComplete>
          <small class="p-invalid" v-if="errors.productoSelected">{{
            errors.productoSelected[0]
          }}</small>
        </div>

        <div class="field col-12 md:col-4">
          <span><strong>OBSERVACIONES:</strong></span>
          <Textarea
            v-model="observaciones"
            :autoResize="true"
            :rows="1"
            placeholder="Observaciones"
          ></Textarea>
        </div>
        <div class="field col-12 md:col-2">
          <span><strong>ACCIONES:</strong></span>
          <Button
            label="REGISTRAR"
            icon="pi pi-save"
            class="p-button-info p-button-lg"
            v-tooltip.top="'Registrar Movimiento'"
            @click="guardarMovimiento"
            :disabled="sucursales.length <= 1"
          />
        </div>
      </div>
    </div>
    <div class="mt-4">
      <DataTable
        ref="traspasos"
        key="id"
        :value="traspasos"
        responsiveLayout="scroll"
        :loading="enviando"
        class="p-datatable-sm"
        responsive="true"
        editMode="cell"
        stripedRows
        showGridlines
        selectionMode="single click"
        @cell-edit-complete="guardandoCambiosCelda"
      >
        <template #loading
          ><div class="flex align-items-center justify-content-center">
            <ProgressSpinner /></div
        ></template>
        <template #empty>
          <div class="flex align-items-center justify-content-center">
            <div class="p-invalid">No existen Productos en el detalle!</div>
          </div>
        </template>
        <Column header="#" class="text-right" style="width: 2em">
          <template #body="slotProps">
            {{ slotProps.index + 1 }}
          </template>
        </Column>
        <Column
          field="codigo_interno"
          header="CÓD."
          class="text-right"
        ></Column>
        <Column
          v-if="mostrar_codigo_origen"
          field="codigo_origen"
          header="ORIG"
          style="min-width: 60px; max-width: 70px"
          class="text-center"
        >
          <template #body="{ data }">
            <span
              v-if="data.codigo_origen"
              v-tooltip.top="data.codigo_origen"
              class="codigo-origen-badge"
            >
              {{
                data.codigo_origen.length > 6
                  ? data.codigo_origen.substring(0, 6) + "..."
                  : data.codigo_origen
              }}
            </span>
            <span v-else class="text-400">-</span>
          </template>
        </Column>
        <Column field="fabrica_nombre" header="MARCA"></Column>
        <!-- <Column field="proveedor_nombre" header="PROVEEDOR"></Column> -->
        <Column
          field="producto"
          header="DETALLE/PRODUCTO"
          style="font-weight: bold"
        >
          <template #body="{ data }">
            <span>{{ data.producto }}</span>
            <span
              v-if="data.unidad_medida_nombre"
              style="
                font-size: 0.8em;
                background: #007ad9;
                color: white;
                padding: 2px 6px;
                border-radius: 4px;
                margin-left: 3px;
              "
              >{{ data.unidad_medida_nombre }}</span
            >
          </template>
        </Column>
        <Column class="text-center bold" field="stock_actual" header="STOCK">
          <template #body="{ data }">
            <div :class="claseEstado(data)">
              {{ data.stock_actual }}
            </div>
          </template>
        </Column>
        <Column
          class="text-center bold bg-green-200"
          field="cantidad"
          header="CANTIDAD"
          style="font-weight: bold; color: #000000"
        >
          <template #body="slotProps">
            {{ slotProps.data.cantidad }}
          </template>
          <template #editor="slotProps">
            <InputNumber
              :inputClass="'text-right'"
              :min="0"
              :minFractionDigits="0"
              locale="de-DE"
              v-model="slotProps.data.cantidad"
            />
          </template>
        </Column>
        <!-- <Column field="precio_compra" header="PUCompra" class="text-right">
            {{ data.precio_compra }}
          </Column>
          <Column
            class="text-right strong"
            field="precio_venta"
            header="PUVenta"
          >
            <template #body="slotProps">
              {{ convertirNumeroGermanicFormat(slotProps.data.precio_venta) }}
            </template>
            <template #editor="{ data, field }">
              <InputNumber
                v-model="data[field]"
                input-class="flex-row-reverse"
                locale="de-DE"
                class="p-inputtext-sm"
                :min="1"
                :minFractionDigits="2"
                :maxFractionDigits="2"
              />
            </template>
          </Column> -->
        <Column header="ACCIONES" style="width: 100px" class="text-center">
          <template #body="slotProps">
            <Button
              @click="quitarProductoDetalle(slotProps)"
              v-tooltip.top="'Quitar Producto'"
              icon="pi pi-times"
              class="p-button-rounded p-button-danger p-button-text"
            />
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>
<script>
import SucursalService from "@/service/SucursalService";
import ProductService from "@/service/ProductService";
import MovimientoInventarioService from "@/service/MovimientoInventarioService";
import UserService from "@/service/UserService";
import { useAuth } from "@/stores";
import ParametrosService from "@/service/ParametrosService";

export default {
  data() {
    return {
      traspasos: [],
      sucursalSelected: 1,
      sucursalDestinoSelected: 2,
      sucursales: [],
      tipoMovimientos: [],
      tipoMovimientoSelected: 1,
      productoSelected: null,
      productosListadoFiltrado: [],
      fecha_movimiento: new Date(),
      enviando: false,
      errors: {},
      stockClass: (data) => {
        if (data <= 0) {
          return "outofstock";
        } else if (data <= 10) {
          return "lowstock";
        } else {
          return "instock";
        }
      },
      claseEstado: (data) => {
        if (data.stock_actual <= 0) {
          return "outofstock";
        } else if (data.stock_actual <= 10) {
          return "lowstock";
        } else {
          return "instock";
        }
      },
      users: [],
      userSelected: null,
      observaciones: "",
      userRecibeSelected: null,
      parametros: [],
      mostrar_codigo_origen: false,
    };
  },
  sucursalService: null,
  productService: null,
  movimientoInventarioService: null,
  userService: null,
  auth: null,
  parametrosService: null,
  created() {
    this.sucursalService = new SucursalService();
    this.productService = new ProductService();
    this.movimientoInventarioService = new MovimientoInventarioService();
    this.userService = new UserService();
    this.auth = useAuth();
    this.parametrosService = new ParametrosService();
  },
  mounted() {
    this.cargarSucursales();
    this.cargarUsuarios();
    this.cargarParametros();
  },
  methods: {
    cargarParametros() {
      this.parametrosService.getAll().then((data) => {
        this.parametros = data.parametros || [];
        this.parametros.forEach((parametro) => {
          if (
            parametro.nombre == "mostrar_codigo_origen" &&
            parametro.estado == 1
          ) {
            this.mostrar_codigo_origen = true;
          }
        });
      });
    },

    cargarUsuarios() {
      this.userService.getUsersAll().then((data) => {
        this.users = data;
        //cargo el usuario logueado
        this.users.forEach((user) => {
          if (user.id == this.auth.user.id) {
            this.userSelected = user.id;
          }
        });
      });
    },
    convertirNumeroGermanicFormat(numero) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(numero);
    },
    validarFormulario() {
      if (
        this.sucursalSelected == null ||
        this.sucursalDestinoSelected == null
      ) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Debe seleccionar una sucursal",
          life: 3000,
        });
        return false;
      }

      if (this.sucursalDestinoSelected == this.sucursalSelected) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "La sucursal de origen y destino no pueden ser iguales",
          life: 3000,
        });
        return false;
      }
      if (this.userSelected == null) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Debe seleccionar un usuario de entrega",
          life: 3000,
        });
        return false;
      }

      if (this.userRecibeSelected == null) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Debe seleccionar un usuario de recepción",
          life: 3000,
        });
        return false;
      }

      if (this.traspasos.length == 0) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Debe agregar al menos un producto al detalle",
          life: 3000,
        });
        return false;
      }
      return true;
    },
    guardarMovimiento() {
      if (this.validarFormulario()) {
        this.enviando = true;
        let datos = {
          sucursal_id: this.sucursalSelected,
          sucursal_destino_id: this.sucursalDestinoSelected,
          productos: this.traspasos,
          user_id: this.userSelected,
          user_recibe_id: this.userRecibeSelected,
          observaciones: this.observaciones,
        };
        this.$confirm.require({
          header: "Confirmación",
          message: "¿ESTÁS SEGURO DE GUARDAR EL MOVIMIENTO?",
          icon: "pi pi-exclamation-triangle",
          acceptLabel: "Si, Guardar",
          rejectLabel: "No, Cancelar",
          acceptClass: "p-button-primary p-button-lg",
          rejectClass: "p-button-danger p-button-lg",
          acceptIcon: "pi pi-save",
          rejectIcon: "pi pi-times",
          discard: () => {
            this.guardando = false;
          },
          accept: () => {
            this.movimientoInventarioService
              .nuevoMovimiento(datos)
              .then((data) => {
                if (data.status == 400) {
                  this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: data.message,
                    life: 3000,
                  });
                  this.enviando = false;
                  return;
                } else {
                  this.$toast.add({
                    severity: "success",
                    summary: "Éxito",
                    detail: data.message,
                    life: 3000,
                  });
                  this.enviando = false;
                  this.traspasos = [];
                  this.observaciones = "";
                  this.userRecibeSelected = null;
                  /* this.imprimirMovimiento(mov_almacen.id); */
                }
              });
          },
          reject: () => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "No se guardo el movimiento",
              life: 3000,
            });
            this.enviando = false;
          },
        });
      }
    },
    /*  imprimirMovimiento(id) {
      this.nuevoMovimiento
        .imprimirMov(id)
        .then(() => {})
        .catch((error) => console.log(error));
    }, */
    guardandoCambiosCelda(e) {
      let { data, newValue, field } = e;
      data[field] = newValue;
      //valido de la cantidad no sea mayor a la existencia
      if (field == "cantidad") {
        if (newValue > data.stock_actual) {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "La cantidad no puede ser mayor al stock actual",
            life: 3000,
          });
          data.cantidad = parseFloat(data.stock_actual);
        }
      }
    },
    agregarProductoDetalle() {
      if (this.productoSelected == null) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Debe seleccionar un producto",
          life: 3000,
        });
        return;
      }
      //Verificar si el producto ya esta en el detalle
      let existe = this.traspasos.find((item) => {
        return item.id == this.productoSelected.id;
      });

      if (existe) {
        this.errors.productoSelect = ["El producto ya esta en el detalle"];
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "El producto ya esta en el detalle",
          life: 3000,
        });
        this.enviando = false;
        return false;
      }

      if (this.cantidad <= 0 || this.cantidad === null) {
        this.errors.cantidad = ["La cantidad debe ser mayor a 0"];
        return false;
      }

      //verifico el stock_actual del producto seleccionado y si no tiene stock no lo agrego al detalle
      if (this.productoSelected.stock[0].cantidad <= 0) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "El producto no tiene stock",
          life: 3000,
        });
        return false;
      }

      let producto = this.productoSelected;
      let cantidad = 1;
      let detalle = {
        id: producto.id,
        codigo_interno: producto.codigo_interno,
        producto: producto.descripcion,
        stock_actual: parseFloat(producto.stock[0].cantidad),
        cantidad: parseFloat(cantidad),
        precio_compra: parseFloat(producto.stock[0].cpp) || 0,
        precio_venta: parseFloat(producto.stock[0].ultimo_precio) || 0,
        margen:
          parseFloat(producto.stock[0].ultimo_precio) -
          parseFloat(producto.precio_compra),
        margen_porcentaje:
          (parseFloat(producto.stock[0].ultimo_precio) /
            parseFloat(producto.precio_compra)) *
          100,
        redondeo:
          parseFloat(producto.precio_compra) +
          parseFloat(producto.stock[0].ultimo_precio) -
          parseFloat(producto.precio_compra),
        fabrica_nombre: producto.fabrica_nombre,
        proveedor_nombre: producto.fabricas.proveedor.nombre_completo,
        unidad_medida_nombre: producto.unidad_medida_nombre,
        codigo_origen: producto.codigo_origen,
      };

      this.traspasos.push(detalle);
      this.productoSelected = null;
    },
    buscarProducto(event) {
      setTimeout(() => {
        this.productService
          .buscarXNombre({
            texto: event.query,
            sucursal_id: this.sucursalSelected,
          })
          .then((response) => {
            this.productosListadoFiltrado = [...response.productos];
          })
          .catch((error) => console.log(error));
      }, 250);
    },
    cargarSucursales() {
      this.sucursalService
        .getSucursalesAll()
        .then((response) => {
          response.forEach((sucursal) => {
            this.sucursales.push(sucursal);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    quitarProductoDetalle(datos) {
      this.$confirm.require({
        header: "Confirmación",
        message: "¿ESTÁS SEGURO DE QUITAR EL PRODUCTO DEL DETALLE?",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Si, Quitar",
        rejectLabel: "No, Cancelar",
        acceptClass: "p-button-primary p-button-lg",
        rejectClass: "p-button-danger p-button-lg",
        acceptIcon: "pi pi-save",
        rejectIcon: "pi pi-times",
        discard: () => {
          this.guardando = false;
        },
        accept: () => {
          this.traspasos.splice(datos.index, 1);
          this.$toast.add({
            severity: "success",
            summary: "Éxito",
            detail: "Producto quitado del detalle",
            life: 3000,
          });
        },
        reject: () => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "No se quito el producto del detalle",
            life: 3000,
          });
        },
      });
    },
  },
  watch: {
    sucursalSelected() {
      //recorro las sucursales para obtener el id de la sucursal destino
      this.sucursales.forEach((sucursal) => {
        if (sucursal.id != this.sucursalSelected) {
          this.sucursalDestinoSelected = sucursal.id;
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/demo/badges.scss";
.p-invalid {
  color: red;
}
.p-fondo {
  background-color: #7bffae;
  border-radius: 5px;
  border: 1px solid #002236;
  padding: 5px;
}
.outofstock {
  font-weight: 700;
  color: #000000;
  background-color: #ff5252;
  padding: 0 0.5em;
  border-radius: 0.5em;
}

.lowstock {
  font-weight: 700;
  color: #000000;
  background-color: #fbc02d;
  padding: 0 0.5em;
  border-radius: 0.5em;
}

.instock {
  font-weight: 700;
  color: #000000;
  background-color: #7bffae;
  padding: 0 0.5em;
  border-radius: 0.5em;
}
</style>
